const unauthorized = {
  title: 'An error has occurred',
  subtitle: 'The content on this page belongs to another customer account. Unfortunately, you are not authorized to access the content.',
  button: {
    startPage: 'Homepage',
    productSearch: 'Product Search',
    prescriptionUpload: 'Upload (E-)Prescription',
    login: 'Login',
    userAccount: 'User Account',
  },
}

export default unauthorized
